import { FC, useContext } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import Card from '../Card/Card';
import common from '../../util/scss/common.module.scss';
import styles from './MigrateStaffAccountVerify.module.scss';
import CoBranding from '../CoBranding/CoBranding';
import { IconMailWoosh } from '../../icons/Icons';
import MigrateStaffAccountContext from '../../contexts/MigrateStaffAccountContext';
import { Button, useTheme } from '@mui/material';

const MigrateStaffAccountVerify: FC = () => {
    const { language, coBranding, fullLoginLink } = useContext(GlobalContext);
    const theme = useTheme();
    const { email } = useContext(MigrateStaffAccountContext);

    const handleLogin = () => {
        window.location.assign(fullLoginLink);
    };

    return (
        <Card>
            {(coBranding.logoUrl || coBranding.name) && (
                <CoBranding logoUrl={coBranding.logoUrl} name={coBranding.name} />
            )}
            <section className={`${common.icon}`}>
                <IconMailWoosh fillColor={theme.palette.grey[900]} />
            </section>
            <header>
                <h1 className={`${common.pageHeader} ${common.withSubhead}`}>
                    {language.staffAccountMigration.verify.title}
                </h1>
                <p className={`${common.pageSubhead} ${styles.successDesc}`}>
                    {language.staffAccountMigration.verify.desc}
                </p>
                <span className={styles.email} data-testid="user-email">
                    {email}
                </span>
            </header>
            <section className={styles.cta}>
                <Button variant="contained" type="button" onClick={handleLogin} size="large">
                    {language.staffAccountMigration.verify.cta}
                </Button>
            </section>
        </Card>
    );
};

export default MigrateStaffAccountVerify;
